import { useDispatch, useSelector } from 'react-redux';
import { brandActions } from '../../../store/modules/brand';

export const useBrandDetailStatistic = (storeId) => {
  const dispatch = useDispatch();

  // redux store에서 브랜드 통계정보 조회
  const selectBrandDetailStatistic = (state) => state.brand.brandDetail.statistic;
  const brandDetailStatisticInfo = useSelector(selectBrandDetailStatistic);

  /**
   * @name getBrandDetailStatistic
   * @description [브랜드 상세] 통계정보 가져오기
   * @param {object} options
   *
   * @returns void
   * */
  const getBrandDetailStatistic = (options) => {
    dispatch(brandActions.getBrandDetailStatistic({ storeId, ...options }));
  };

  return { getBrandDetailStatistic, brandDetailStatisticInfo };
};
